// library
import { FC } from "react";

const Footer: FC<any> = () => {

    return (
        <footer>
            <div className="footer-bar">
                <div className="footer-logo-wrapper">
                    <img
                        className="footer-title-logo"
                        src={"./icons/title-logo.svg"}
                        height={20}
                        alt="イベントマップタイトル"
                    />
                </div>
                <div className="footer-copyright">
                    <p>
                        Copyright © 2025 Event Map. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;